import { Navigate, useLocation } from "react-router-dom";
import { roleAllows, useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, adminOnly = false, allowedRoles = null }) {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-checking">
        <div className="text-[color:var(--cc-ink-muted)] text-sm">Loading…</div>
      </div>
    );
  }
  // CC-158 (2026-10-05) — preserve the target URL across /login so an
  // emailed deep link (e.g. the Send-for-Approval link to a payroll run)
  // survives the sign-in redirect. Prior behavior: `<Navigate to="/login" replace />`
  // with no state → Login.jsx always redirected to /{slug}/app/overview
  // after sign-in, silently dropping the deep link on the floor.
  if (!user) {
    const target = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/login" replace state={{ from: target }} />;
  }
  if (adminOnly && user.role !== "platform_admin") return <Navigate to="/app/overview" replace />;
  if (allowedRoles && !roleAllows(user.role, allowedRoles)) return <Navigate to="/app/overview" replace />;
  return children;
}
